import { Component, ChangeDetectionStrategy, ViewChild, TemplateRef, Input, SimpleChanges, Injector, OnInit, AfterViewInit } from '@angular/core';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { isSameDay, isSameMonth } from 'date-fns';
import { Subject } from 'rxjs';
import { modalDataI } from 'app/core/interfaces/schedule';
import { cardColors } from 'app/core/data/calendar.json';
import * as moment from 'moment';
import { MatDialogConfig } from '@angular/material/dialog';
import { CalendarDayOptionsComponent } from '../../components/calendar-day-options/calendar-day-options.component';
import { Practitioner } from 'app/core/interfaces/practitioner';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';

@Component({
  selector: 'practitioner-page-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PractitionerSchedulerComponent extends BaseComponent implements OnInit, AfterViewInit {
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any> = <any>{};
  @ViewChild('customMonthCell', { static: true }) customMonthCell!: TemplateRef<any>;
  @Input() encounters: any[] = [];

  holdTimeout: any;
  heldDate: Date | null = null;
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  modalData: modalDataI = <modalDataI>{};
  refresh = new Subject<void>();
  events: any[] = [];
  activeDayIsOpen: boolean = true;

  public mobile = false;

  actions: CalendarEventAction[] = [
    {
      label: '<mat-icon color="primary">edit</mat-icon>',
      a11yLabel: 'Editar',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<mat-icon color="primary">trash</mat-icon>',
      a11yLabel: 'Remover',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  public practitioner!: Practitioner;
  public userLogged = {
    name: '',
    id: '',
  };

  constructor(private injector: Injector, private practitionerService: PractitionerService) {
    super(injector);
  }

  ngOnInit() {
    const user = this.currentUser.user;
    this.userLogged = {
      name: user,
      id: user.id,
    };
    this.getPractitioner(this.userLogged.id);
    this.events = this.addEvent(this.encounters);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['encounters']) {
      const newEncounters = changes['encounters'].currentValue;
      this.events = this.addEvent(newEncounters);
    }
  }

  ngAfterViewInit(): void {
    this.setHeader();
  }

  setHeader() {
    if (window.innerWidth < 768) {
      console.log(window.innerWidth);
      setTimeout(() => {
        document
          .querySelectorAll('.cal-header .cal-cell')
          .forEach((item: Element) => (item.innerHTML = (item as HTMLElement).innerText.substring(0, 3).toUpperCase()));
      }, 300);
    }
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  showViewDate() {}

  eventTimesChanged({ event, newStart, newEnd }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {}

  getModifiedDayType(date: Date): 'holiday' | 'blockSchedule' | null {
    if (!this.practitioner?.modifiedDays) return null;

    const target = moment(date).format('YYYY-MM-DD');
    const match = this.practitioner.modifiedDays.find((item: any) => {
      return moment(item.date).format('YYYY-MM-DD') === target;
    });

    return match?.type || null;
  }

  timeFormat(date: any) {
    if (!moment.isMoment(date)) {
      date = moment(date);
    }
    return date.format('HH:mm');
  }

  addEvent(encounter: any[]) {
    const events = encounter.map((item, index) => {
      let event = {};
      if (item.type === 'Consulta') {
        event = {
          start: moment(item.startDate).toDate(),
          end: moment(item.startDate).add(30, 'minute').toDate(),
          title: `<div class="left event-content">
                <b>${item.type}</b>
                <br> <b>Especialista:</b> ${item.practitioner.name}
                <br> <b>Procedimento:</b> ${item.name}
                <br> <b>Paciente:</b> ${item.patient.name}
                <br> <div class="event-hour"><b>Hora:</b> ${this.timeFormat(item.startDate)}</div>
              </div>`,
          color: { ...cardColors['blue'] },
          allDay: false,
          resizable: {
            beforeStart: true,
            afterEnd: true,
          },
        };
      } else if (item.type === 'Exame') {
        event = {
          start: moment(item.startDate).toDate(),
          end: moment(item.startDate).add(30, 'minute').toDate(),
          title: `<div class="left event-content">
                <b>${item.type}</b>
                <br> <b>Especialista:</b> ${item.practitioner.name}
                <br> <b>Procedimento:</b> ${item.name}
                <br> <b>Paciente:</b> ${item.patient.name}
                <br> <div class="event-hour"><b>Hora:</b> ${this.timeFormat(item.startDate)}</div>
              </div>`,
          color: { ...cardColors['yellow'] },
          actions: undefined,
          resizable: {
            beforeStart: true,
            afterEnd: true,
          },
        };
      }
      return event;
    });

    return events;
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
    this.setHeader();
  }

  getPractitioner(practitioner_id: string) {
    this.practitionerService.showNew(practitioner_id).subscribe({
      next: (practitioner: any) => {
        this.practitioner = practitioner;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
    this.setHeader();
  }

  onDayMouseDown(date: Date) {
    this.holdTimeout = setTimeout(() => {
      this.openDayOptionsModal(date);
    }, 1000);
  }

  onDayMouseUp() {
    clearTimeout(this.holdTimeout);
  }

  getLabelByType(type: string) {
    if (window.innerWidth <= 430) {
      return 'x';
    }
    return type === 'holiday' ? 'Feriado' : 'Bloqueado';
  }

  openDayOptionsModal(date: Date) {
    const formattedDate = moment(date).format('YYYY-MM-DDTHH:mm:ssZ');
    let alreadyModified = this.practitioner?.modifiedDays ?? null;

    if (alreadyModified) {
      alreadyModified = this.practitioner?.modifiedDays?.find((item: any) => item.date.startsWith(formattedDate.split('T')[0]));
    }

    const data = {
      param: {
        date: formattedDate,
        practitioner: this.practitioner,
        existingModification: alreadyModified ?? null,
      },
    };

    const config: MatDialogConfig = {
      width: '400px',
      maxWidth: '90%',
      minHeight: '200px',
    };

    const dialogRef = this.dialog.openComponentDialog(CalendarDayOptionsComponent, data, config).subscribe((res: any) => {
      console.log('res', res);
      if (res) {
        window.location.reload();
      }
    });
  }
}
